export const ROLE_ADMIN = 'Admin';
export const ROLE_USER = 'User';
export const ROLE_EMPLOYEE = 'Angestellter';

export const ROLE_SELECT = [
  {_id: ROLE_USER, name: 'Sammler'},
  {_id: ROLE_EMPLOYEE, name: ROLE_EMPLOYEE},
  {_id: ROLE_ADMIN, name: ROLE_ADMIN},
];

export function getTranslatedRole(role) {
  const {name} = ROLE_SELECT.find(({_id}) => _id === role) || {};
  return name || role;
}



// WEBPACK FOOTER //
// ./src/constants/userConstants.js